import { Text } from '@thanx/uikit/text'
import { useGetRecoveryStatusQuery } from 'api/recoveryAi'
import LockCircled from 'assets/images/billing/img_lock-circled.svg'
import { FeedbackTableLinkState } from 'components/FeedbackTable'
import Spinner from 'components/Spinner'
import useFlag from 'hooks/useFlag'
import { buildTranslate } from 'locales'
import React from 'react'
import type { StaticContext } from 'react-router'
import { Redirect, RouteComponentProps } from 'react-router-dom'
import {
  isOrderFeedbackTabVisible,
  useInboxMountState,
} from 'scenes/FeedbackInbox/useInboxMountState'
import { useAbility } from 'utilities/ability'
import RatingDetail from './OrderFeedbackReport/RatingDetail'

const t = buildTranslate('order_feedback')
const errorsT = buildTranslate('errors')
const LOCK_ICON_WIDTH_PX = 32

const RatingDetailOrInboxRedirect = (
  props: RouteComponentProps<
    { ratingId: string },
    StaticContext,
    FeedbackTableLinkState
  >
) => {
  const ability = useAbility()
  const unifiedInboxEnabled = useFlag(
    'recovery-ai-unified-feedback-inbox',
    false
  )
  const inboxMountState = useInboxMountState(unifiedInboxEnabled)
  const { data: status } = useGetRecoveryStatusQuery(undefined, {
    skip: !unifiedInboxEnabled,
  })

  if (!unifiedInboxEnabled) return <RatingDetail {...props} />

  if (inboxMountState.isLoading) {
    return (
      <Spinner isLoading size="4x" className="text-center margin-top-huge" />
    )
  }

  const { ratingId } = props.match.params
  const canAccessMerchantSettings = ability.can('access', 'MerchantSettings')
  const isOrderFeedbackTabShown = isOrderFeedbackTabVisible({
    ...inboxMountState,
    canAccessFeedback: ability.can('access', 'Feedback'),
    canAccessMerchantSettings,
  })

  // `kind=all`: the default segment omits ratings without a comment.
  if (isOrderFeedbackTabShown) {
    return (
      <Redirect to={`/order_feedback?kind=all&item=${ratingId}#feedback`} />
    )
  }

  if (canAccessMerchantSettings && status?.active) {
    return (
      <Redirect to={`/recovery_ai/escalations?kind=all&item=${ratingId}`} />
    )
  }

  const isFeedbackDisabled =
    !inboxMountState.writtenFeedbackEnabled && status?.active === false

  return (
    <div className="text-center pt-xl">
      <img src={LockCircled} alt="" width={LOCK_ICON_WIDTH_PX} />
      <Text.Header4 bold color="grey90" className="mt-m mb-xs">
        {isFeedbackDisabled
          ? t('feedback_disabled.title')
          : errorsT('forbidden_title')}
      </Text.Header4>
      <Text.BodyText3 color="grey70" tag="p">
        {isFeedbackDisabled
          ? t('feedback_disabled.message')
          : errorsT('forbidden_message')}
      </Text.BodyText3>
    </div>
  )
}

export default RatingDetailOrInboxRedirect
